export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname
// Rounds a price up to 2 decimals and always shows 2 digits, e.g. 102.925 -> "102.93"
export const roundUpToTwoDecimals = (value: number): string => {
  const cents = Number((value * 100).toFixed(4))
  return (Math.ceil(cents) / 100).toFixed(2)
}
export const handleDataLayer = (name: string, category: string, action: string, label: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: name,
      category: category,
      action: action,
      label: label
    });
  };